import { useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';

/**
 * Subscribe to admin-relevant socket events: inventory:changed and
 * pricing:applied. Returns a recent-events buffer + a connect indicator.
 *
 * Usage:
 *   const { events, connected } = useAdminSocket();
 *   useEffect(() => { if (events.length) reload(); }, [events.length]);
 */
export default function useAdminSocket() {
  const [events, setEvents] = useState([]);
  const [connected, setConnected] = useState(false);
  const sockRef = useRef(null);

  useEffect(() => {
    const url = process.env.REACT_APP_SOCKET_URL || (window.location.origin);
    const socket = io(url, { transports: ['websocket', 'polling'] });
    sockRef.current = socket;

    socket.on('connect',    () => setConnected(true));
    socket.on('disconnect', () => setConnected(false));

    const push = (kind) => (payload) => {
      setEvents(prev => [{ kind, payload, at: Date.now() }, ...prev].slice(0, 50));
    };
    socket.on('inventory:changed', push('inventory:changed'));
    socket.on('pricing:applied',   push('pricing:applied'));
    socket.on('orders:new',        push('orders:new'));
    socket.on('auction:ended',     push('auction:ended'));
    socket.on('leads:new',         push('leads:new'));
    socket.on('payments:failed',   push('payments:failed'));

    return () => { socket.disconnect(); };
  }, []);

  return { events, connected, socket: sockRef.current };
}
